module.exports = __webpack_public_path__ + "static/icon-noproblem-b5e134f94a8a9e7271221d0a5a401f79.png";